<script setup lang="ts">
import FadeTransition from '../transition/FadeTransition.vue'

interface Props {
  active?: boolean
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <FadeTransition>
    <div v-if="active" class="fixed top-0 left-0 bg-black/80 w-full h-screen" v-bind="$attrs"></div>
  </FadeTransition>
</template>
